// extracted by mini-css-extract-plugin
module.exports = {"newsPill":"styles_newsPill__e0VNF","new":"styles_new__7rN7x"};